import { render } from "./Vnud-Consultores.vue?vue&type=template&id=4fa0eec0"
import script from "./Vnud-Consultores.vue?vue&type=script&lang=js"
export * from "./Vnud-Consultores.vue?vue&type=script&lang=js"

import "./Vnud-Consultores.vue?vue&type=style&index=0&id=4fa0eec0&lang=css"

import exportComponent from "C:\\Users\\ricar\\OneDrive\\Ambiente de Trabalho\\Projetos\\WIP\\Reorganiza\\Leadcenter\\Dashboard\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__